//设备
const state = {
	ActiveIndex: 0,
	deviceStatus: 0,
	PersonStatus: 0,
};
const getters = {
	ActiveIndex: (state) => state.ActiveIndex,
	deviceStatus: (state) => state.deviceStatus,
	PersonStatus: (state) => state.PersonStatus,
};
const actions = {};
const mutations = {
	CHANGE: (state, ActiveIndex) => {
		state.ActiveIndex = ActiveIndex;
	},
	DEVICESTATUS: (state, deviceStatus) => {
		state.deviceStatus = deviceStatus;
	},
	PERSONSTATUS: (state, PersonStatus) => {
		state.PersonStatus = PersonStatus;
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/equipment.js